import { useEffect, useState } from "react";
import classes from "./programList.module.css";
import axios from "../../../../requests/axios";
import routes from "../../../../requests/routes";
import Loader from "../../../../layouts/loader/Loader";
import TableWithExport from "../../../../generic components/TableWithExport/TableWithExport";
import {
  fmtDate,
  getCreated,
  getEmail,
  getName,
} from "../../../../generic components/TableWithExport/TableWithExport.utils";
import {
  Image,
  message,
  Space,
  Switch,
  Tag,
  Typography,
  Button,
  Modal,
} from "antd";
import { EditOutlined } from "@ant-design/icons";

const { Text } = Typography;
import { Link } from "react-router-dom";
import DuplicateButton from "./DuplicateButton/DuplicateButton";
const ProgramList = (props) => {
  const { setModalOpen } = props;
  const [adminPrograms, setAdminPrograms] = useState([]);
  const [loading, setLoading] = useState(false);

  const togglePublish = async (record, checked, attr) => {
    try {
      await axios
        .patch(`${routes.createProgram}/${record._id}`, {
          [attr]: checked,
        })
        .then(() => {
          message.success("Publish state updated!");
        });
      getPrograms();
    } catch (e) {
      message.error("Failed to update publish state");
    }
  };
  async function getPrograms() {
    try {
      const response = await axios.get(routes.getAdminPrograms);
      setAdminPrograms(response.data.programs);
      setLoading(false);
    } catch (err) {}
  }

  const tripsTypes = [
    {
      id: 0,
      name: "Volunteering",
    },
    {
      id: 1,
      name: "Adventurous & Road trips",
    },
    {
      id: 2,
      name: "Have a Dream Juniors",
    },
    {
      id: 3,
      name: "EU program",
    },
    {
      id: 4,
      name: "Special Requests",
    },
  ];
  const columns = [
    { title: "#", width: 64, align: "center", render: (_v, _r, i) => i + 1 },
    {
      title: "Image",
      sorter: (a, b) => getName(a).localeCompare(getName(b)),
      render: (_, r) => <Image height={50} width={50} src={r.image} />,
    },
    {
      title: "Name",
      sorter: (a, b) => getName(a).localeCompare(getName(b)),
      render: (_, r) => (
        <Text strong copyable>
          {getName(r) || "—"}
        </Text>
      ),
    },
    {
      title: "Location",
      sorter: (a, b) => getEmail(a).localeCompare(getEmail(b)),
      render: (_, r) => <Text copyable>{r.location}</Text>,
    },
    {
      title: "Type",
      responsive: ["md"],
      render: (_, r) =>
        tripsTypes.map((trip) => parseInt(r.type) === trip.id && trip.name),
    },

    {
      title: "Spots Available",
      responsive: ["md"],
      render: (_, r) => r.spotsAvailable,
    },
    {
      title: "Published",
      width: 130,
      render: (_, r) => (
        <Space>
          <Switch
            checked={!!r.isPublished}
            onChange={(c) => togglePublish(r, c, "isPublished")}
          />
          {r.isPublished ? (
            <Tag color="green">Published</Tag>
          ) : (
            <Tag>Draft</Tag>
          )}
        </Space>
      ),
    },
    {
      title: "Home page",
      width: 130,
      render: (_, r) => (
        <Space>
          <Switch
            checked={!!r.isHomepage}
            onChange={(c) => togglePublish(r, c, "isHomepage")}
          />
          {r.isHomepage ? <Tag color="green">Published</Tag> : <Tag>Draft</Tag>}
        </Space>
      ),
    },

    {
      title: "Created",
      sorter: (a, b) =>
        new Date(getCreated(a) || 0) - new Date(getCreated(b) || 0),
      render: (_, r) => fmtDate(getCreated(r)),
    },

    {
      title: "Actions",
      fixed: "right",
      width: 120,
      render: (_, record) => (
        <div style={{ display: "flex", gap: "1rem" }}>
          <Space>
            <Link
              to={`/admin/programs/${record._id}/main`}
              style={{ display: "flex", gap: ".5rem", alignItems: "center" }}
            >
              <EditOutlined />
              Edit
            </Link>
          </Space>
          <DuplicateButton record={record} getPrograms={getPrograms} />
          <Button
            danger
            type="link"
            onClick={() => {
              Modal.confirm({
                title: "Delete program",
                content: "Are you sure you want to delete this program?",
                okText: "Delete",
                okType: "danger",
                cancelText: "Cancel",
                onOk: async () => {
                  try {
                    await axios.delete(routes.createProgram + "/" + record._id);
                    message.success("Program deleted");
                    await getPrograms();
                  } catch (e) {
                    message.error("Failed to delete program");
                  }
                },
              });
            }}
          >
            Delete
          </Button>
        </div>
      ),
    },
  ];

  useEffect(() => {
    getPrograms();
  }, []);

  return (
    <div className={classes.programsTable}>
      {loading ? (
        <Loader color={"#F46444"} />
      ) : (
        <TableWithExport
          columns={columns}
          data={adminPrograms}
          loading={loading}
          tableName="program"
          filters={false}
          enableReorder
          disableExport={true}
          addRow={setModalOpen}
          onReorder={async (ids, orderedRows) => {
            await axios.patch(routes.reorderPrograms, { ids });
            await getPrograms();
          }}
        />
      )}
    </div>
  );
};

export default ProgramList;
